import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Magnetic, Reveal } from "./Reveal";
import { CONTACT } from "../data/content";

export const CtaBand = ({ title, text }) => (
  <section className="bg-white py-24 md:py-32" data-testid="cta-band">
    <div className="container-x">
      <Reveal>
        <div className="relative bg-navy bg-grain text-white p-10 md:p-14 lg:p-20 overflow-hidden rounded-2xl">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-herald" aria-hidden="true" />
          <img
            src="/images/marke/farbfaecher-logo.jpg"
            alt="Farbfächer mit dem Wappen von Manfred Berglar, Malermeister"
            className="absolute right-0 top-0 h-full w-[42%] object-cover opacity-25 pointer-events-none select-none hidden lg:block"
          />
          <div className="absolute inset-y-0 right-0 w-[42%] bg-gradient-to-r from-navy via-navy/60 to-transparent pointer-events-none hidden lg:block" aria-hidden="true" />
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-end relative">
            <div className="lg:col-span-8">
              <p className="kicker-dark">Nächster Schritt</p>
              <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.08] mt-4 max-w-2xl">
                {title}
              </h2>
              {text && <p className="text-white/65 leading-relaxed mt-4 max-w-lg">{text}</p>}
            </div>
            <div className="lg:col-span-4 flex flex-col items-start gap-5">
              <Magnetic>
                <Link to="/kontakt" data-testid="ctaband-cta" className="btn-light">
                  Projekt anfragen <ArrowUpRight size={16} />
                </Link>
              </Magnetic>
              <a
                href={CONTACT.phoneHref}
                data-testid="ctaband-phone"
                className="font-mono text-sm font-semibold tracking-wide text-white/70 hover:text-herald transition-colors duration-300 inline-flex items-center min-h-[44px]"
              >
                Oder direkt: {CONTACT.phoneDisplay}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
